import { Injectable } from "@angular/core";
import { Subject, BehaviorSubject } from "rxjs";

import { NotificationQuotation } from "../../_models/notificationQuotation";

@Injectable({ providedIn: 'root' })
export class PartsfyNotificationService {
    public totalMensagensNaoLidasSubject = new Subject<number>();
    public totalMensagensNaoLidas = this.totalMensagensNaoLidasSubject.asObservable();

    public notificationListSubject = new BehaviorSubject<NotificationQuotation[]>([]);
    notificationList = this.notificationListSubject.asObservable();

    public notificacaoSelecionadaSubject = new Subject<NotificationQuotation>();
    notificacaoSelecionada = this.notificacaoSelecionadaSubject.asObservable();

    constructor() { }

    public abrirNotificacoes(notificacao) {
        this.notificacaoSelecionadaSubject.next(notificacao);
    }

    public adicionarNotification(notification: NotificationQuotation) {
        let notifications = this.notificationListSubject.value;

        // Verifica se já existe alguma notificação para essa cotação
        if (!notifications.find(n => n.order_id === notification.order_id)) {
            // Se não existir, adiciona
            notifications.push(notification);
            this.notificationListSubject.next(notifications);
        }
    }

    public atualizarNotifications(notifications: NotificationQuotation[]) {
        this.notificationListSubject.next(notifications);
        this.atualizarTotalMsgsNaoLidas();
    }

    public atualizarTotalMsgsNaoLidas() {
        var totalMsgsNaoLidas = this.notificationListSubject.value.filter(n => n.status_id === 0).length;
        this.totalMensagensNaoLidasSubject.next(totalMsgsNaoLidas);
    }
}
